import angular from 'angular';

import { UserStatusService } from './user-status.service';

angular.module('app.global.user-status', []).service('UserStatusService', UserStatusService);
